import { render, staticRenderFns } from "./NewFeedItem.vue?vue&type=template&id=30062a0a&scoped=true&"
import script from "./NewFeedItem.vue?vue&type=script&lang=js&"
export * from "./NewFeedItem.vue?vue&type=script&lang=js&"
import style0 from "./NewFeedItem.vue?vue&type=style&index=0&id=30062a0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30062a0a",
  null
  
)

export default component.exports